import { authClient, API } from '../index'

export const getPurchases = () => {
  return authClient().get(`${API}/purchases`)
}

export const getPurchaseById = (id) => {
  return authClient().get(`${API}/purchases/${id}`)
}

export const getUserHasPayedSubscription = (userId) => {
  return authClient().get(`${API}/purchases/user-payed/${userId}`)
}

export const deletePurchase = (id) => {
  return authClient().delete(`${API}/purchases/${id}`)
}

export const postPurchase = (purchase) => {
  return authClient().post(`${API}/purchases`, purchase)
}

export const updatePurchase = (id, purchase) => {
  return authClient().put(`${API}/purchases/${id}`, purchase)
}

export const stripeSubscription = () => {
  return authClient().get(`${API}/purchases/stripe/subscription`)
}

export const getStripeVisits = () => {
  return authClient().get(`${API}/purchases/stripe/visit`)
}

export const stripeCheckout = (token, price, visit) => {
  return authClient().post(`${API}/purchases/stripe/checkout`, { token, price, visit })
}
